module.exports = __webpack_public_path__ + "img/teambox-image.0e6cabfc.png";